import React from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import TierIconSmall from '@wix/da-ds/pkg/Icons/16x16/Tier';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import useIconSizeForButtonSize from '@wix/da-ds/pkg/Buttons/hooks/useIconSizeForButtonSize';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useSubscribeButton } from '../useSubscribeButton';

import s from './Subscribe.scss';

export interface Props {
  tier: PapiDeviation;
  /** should display the price per month? */
  withPrice?: boolean;
  withSaleIndicator?: boolean;
  className?: string;
  href?: string;
  size?: ButtonSize;
}

const SubscribeVariant: React.FC<Props> = ({
  tier,
  withPrice = false,
  withSaleIndicator = false,
  size = 'medium',
  className,
  href,
}) => {
  const { onClick, biData, text } = useSubscribeButton(tier, {
    type: 'subscribe',
    withPrice,
    withSaleIndicator: withSaleIndicator,
  });
  const iconSize = useIconSizeForButtonSize(size);
  const icon = iconSize === IconSize.SMALLER ? TierIconSmall : TierIcon;

  return (
    <SolidButton
      isFakeButton
      className={c(s['root'], className)}
      icon={icon}
      size={size}
      variant="main"
      href={href}
      onClick={onClick}
      biData={biData}
    >
      {text}
    </SolidButton>
  );
};
SubscribeVariant.displayName = 'SubscribeVariant';

export default SubscribeVariant;
